<template>
	<nut-navbar
		class="navbar"
		title="服务条款"
		leftShow
		@on-click-back="goBack"
	></nut-navbar>
	<div class="content">
		<h1>多动屏客户端服务条款</h1>
		<h3>一、免责声明</h3>
		<p>
			1.
			用户不得通过本平台制作、上传、存储、发布任何涉及淫秽、色情、赌博、暴力、凶杀、恐怖、反动、迷信、危害国家安全等国家法律所禁止或严重违背社会道德的内容。因用户违背该约定而造成的一切法律和社会责任由该用户自行承担，与七月流火无关。
		</p>
		<p>
			2.
			用户保证所制作、上传、存储、发布的内容均为合法内容；七月流火有权利和义务配合国家相关机关在未告知用户的前提下，对用户制作、上传、发布的内容进行审查。
		</p>
		<p>
			3.
			七月流火会将用户上传的内容在云端存储空间长期保存；但由于云计算供应商、电信运营商等第三方原因或其他无法抗拒的因素造成的内容丢失和损毁，七月流火不负担责任。在上传内容之前用户需妥善做好其他方式的备份。
		</p>
		<p>
			4.
			本平台的服务基于Internet服务，而Internet服务可能会受到各个环节不稳定因素的影响。用户应知晓并能够接受由于网络不稳定等原因造成的影响。
		</p>
		<p>
			5.
			用户需合理设定和妥善保管密码。由于用户密码泄露，进而导致的媒体内容损毁或者多动屏被恶意控制等后果，七月流火不负担责任。
		</p>
		<p>
			6.
			七月流火根据自身业务发展的需要以及客户的意见反馈等前提，会不定期的对所提供的服务、用户界面、设备固件等内容做出适当的修改和升级。用户应知晓由此带来的风险。
		</p>
		<h3>二、使用说明</h3>
		<p>
			7.
			多动屏软件系统的客户端分为微信客户端和电脑桌面客户端。用户可根据需求灵活选择使用。
		</p>
		<h3>三、其他</h3>
		<p>
			8.
			七月流火保留对本服务条款的修改权和最终解释权。
		</p>
		上海七月流火信息技术有限公司
	</div>
</template>

<script>
import useNavigate from '@/hooks/useNavigate';
export default {
	name: 'Agreement',
	setup() {
		const { goBack } = useNavigate();
		return {
			goBack,
		};
	},
};
</script>

<style lang="scss" scoped>
.content {
	font-size: 14px;
	line-height: 24px;
	padding: 12px;

	h1 {
		font-size: 20px;
		text-align: center;
		margin: 10px auto;
	}
	h3 {
		font-size: 16px;
	}
	p {
		text-indent: 2em;
		margin-bottom: 10px;
	}
}
</style>
